import gql from 'graphql-tag';

export const CREATE_STOCKTAKE = gql`
    mutation createStocktakeMutation ($input: CreateStocktakeInput!) {
        createStocktake(input: $input) {
            id
        }
    }
`;
